<template>
  <div class="SocieteContent">
    <div class="title">Informations sur la société</div>
    <div class="row1">
      <Input
        v-model="commission"
        description="Nom Société *"
        datatype="text"
        placeholder="Nom"
      />
      <Input
        v-model="commission"
        description="Code RCS *"
        datatype="text"
        placeholder="code RCS"
      />
      <Input
        v-model="commission"
        description="Ville d'immatriculations RCS *"
        datatype="text"
        placeholder="ville"
      />
      <radio
        :items="iteamRadio"
        v-model="valueRadio"
        label="Possédez-vous la Carte T ?"
      />
    </div>
    <div class="row2">
      <div class="row2col">
        <Input
          v-model="commission"
          description="Nom de l'assureur de la responsabilité cuvile pro"
          datatype="text"
        />
        <Input
        v-model="commission"
        description="Logo"
        datatype="file"
      />
      </div>
      <div class="row2col">
        <Input
          v-model="commission"
          description="Adresse de l'assureur de la responsabilité civile pro"
          datatype="email"
        />
      </div>
    </div>
    <div class="row1">
        <button class="btn" @click="NewCompany">Enregistrer</button>
    </div>
  </div>
</template>

<script>
import Input from "./Input";
import radio from "./radio";
export default {
  data() {
    return {
      commission: null,
      valueRadio: "non",
      iteamRadio: [
        { description: "Oui", value: "oui" },
        { description: "Non", value: "non" },
      ],
    };
  },
  components: {
    Input,
    radio,
  },
  methods:{
      NewCompany(){
          console.log('save',this.commission)
      }
  }
};
</script>

<style scoped lang="scss">
.SocieteContent {
  width: 100%;
  display: inline;
  margin: 10px;
  .title {
    width: 100%;
    color: #068596ba;
    font-weight: bold;
    font-size: 20px;
    margin: 10px;
  }
  .row1 {
    width: 100%;
    display: inline;
     .btn {
      margin-top:25px;
      background-color: #068596fa;
      color: white;
      border: 1px solid #22a1b9;
      border-radius: 3px;
      height: 30px;
      width: 100%;
      &:focus {
        outline: 0;
      }
      &:hover {
        border-color: #ff8c00;
        background-color: #ff8c00;
      }
    }
  }
  .row2 {
    width: 100%;
    display: flex;
    .row2col{
        width: 100%;
    }
  }
}
@media screen and (max-width: 425px) {
.SocieteContent{
  .row2{
    display: inline;
  } 
}
}
</style>
